<template>
    <div>
        <div class="custom-search d-flex justify-content-between mb-2">
            <div>
                <b-button
                        id="importExcelButton"
                        variant="success"
                        class="mr-1"
                        @click="downloadSample"
                >
                    Mintafájl letöltése
                </b-button>
            </div>
        </div>
        <b-card-code
                title="Importálás"
        >
            <ImportSkeleton
                    :key="importKey"
                    :model-type="'App\\Models\\Fisherman'"
                    :columns="columns"
                    :column-titles="columnTitles"
                    :column-definitions="columnDefinitions"
                    :parent-loading="loading"
                    :parent-is-file-valid="isFileValid"
                    :preview-data="previewData"
                    :be-error-messages="beErrorMessages"
                    :preview-error-messages="previewErrorMessages"
                    :with-zip="false"
                    @file-selected="loadPreview"
                    @reset="resetForm"
                    @saved="save"
            />
        </b-card-code>
    </div>
</template>

<script>
import {
    BButton,
    VBTooltip,
} from 'bootstrap-vue'
import FileSaver from 'file-saver'
import ImportSkeleton from '@/views/pages/_components/_import/ImportSkeleton.vue'
import BCardCode from "@core/components/b-card-code";

export default {
    components: {
        BCardCode,
        BButton,
        ImportSkeleton,
        VBTooltip,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            role: 'fisherman',
            columns: [
                'name',
                'gender',
                'nationality',
                'birthday',
                'fishing_card_number',
            ],
            columnTitles: [
                'Név',
                'Nem',
                'Ország',
                'Születési dátum',
                'Horgászkártya száma (horgászazonosító)',
            ],
            columnDefinitions: {},
            beErrorMessages: {
                file: [],
            },
            previewErrorMessages: {},
            previewData: [],
            loading: false,
            isFileValid: false,
            importKey: 0,
        }
    },
    created() {
        this.getValidationRules()
    },
    methods: {
        downloadSample() {
            this.$store.dispatch('downloadFishermanImportSample').then(response => {
                let filename = 'horgaszok-import-minta.xlsx'
                FileSaver.saveAs(response.data, filename)
            })
        },
        getValidationRules() {
            this.loading = true
            this.$store.dispatch('getFishermanImportValidationRules').then(response => {
                this.columnDefinitions = response.data.rules
            }).catch(error => {
                this.$helpers.showErrorToast(error.toString())
            }).finally(() => {
                this.loading = false
            })
        },
        resetForm() {
            this.previewErrorMessages = {}
            this.previewData = []
            this.isFileValid = false
            this.beErrorMessages = {
                file: []
            }
        },
        loadPreview(file) {
            this.loading = true
            this.isFileValid = false
            this.previewErrorMessages = {}
            this.beErrorMessages = {
                file: []
            }

            let fd = new FormData()
            fd.append('file', file)

            this.$store.dispatch('loadFishermanImportPreview', fd).then(response => {
                this.previewData = response.data.data
                this.isFileValid = true
            }).catch(error => {
                let showErrorToast = true
                let toastErrorMessage
                if (error.response && error.response.status === 422) {
                    const responseData = error.response.data

                    if (responseData.extraData && responseData.extraData.previewError) {
                        this.previewErrorMessages = responseData.errors
                        toastErrorMessage = responseData.message
                    } else {
                        this.beErrorMessages = responseData.errors
                        showErrorToast = false
                    }
                }
                if(error.response.status && error.response.status === 413){
                    toastErrorMessage = 'A feltölteni kívánt fájl túl nagy. Maximum feltölthető fájlméret: 10MB'
                    showErrorToast = true
                }

                this.isFileValid = false
                this.previewData = []

                if (showErrorToast) this.$helpers.showErrorToast(toastErrorMessage)
            }).finally(() => {
                this.loading = false
            })
        },
        save(file) {
            this.loading = true

            let fd = new FormData()
            fd.append('file', file)

            this.$store.dispatch('fishermanImport', fd).then(() => {
                this.$helpers.showSuccessToast('Az importálás elkezdődött és a háttérben folytatódik. E-mailben fogjuk értesíteni az eredményről.')

                this.previewData = {}
                this.previewErrorMessages = {}
                this.beErrorMessages = {
                    file: [],
                }
                this.isFileValid = false
                this.importKey++
            }).catch(error => {
                let showErrorToast = true
                let toastErrorMessage = error.response.message
                if (error && error.response && error.response.status && error.response.status === 422) {
                    this.beErrorMessages = error.response.data.errors
                    showErrorToast = false
                }
                if(error.response.status && error.response.status === 413){
                    toastErrorMessage = 'A feltölteni kívánt fájl túl nagy. Maximum feltölthető fájlméret: 10MB'
                    showErrorToast = true
                }

                if (showErrorToast) this.$helpers.showErrorToast(toastErrorMessage)
            }).finally(() => {
                this.loading = false
            })
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
